export interface BoundsBreakdown {
  readonly roundedValue: number;
  readonly dp: number;
  readonly degreeOfAccuracy: string;
  readonly half: string;
  readonly lowerBound: string;
  readonly upperBound: string;
}

/**
 * Calculate upper and lower bounds for a value rounded to `dp` decimal places.
 *
 * Uses string formatting for degree/half to avoid floating-point display artefacts.
 * LB and UB are formatted to `dp + 1` decimal places via `toFixed`.
 */
export function calculateBounds(value: number, dp: number): BoundsBreakdown {
  const degreeOfAccuracy = dp === 0 ? '1' : `0.${'0'.repeat(dp - 1)}1`;
  const halfNum = Math.pow(10, -dp) / 2;
  const half = dp === 0 ? '0.5' : `0.${'0'.repeat(dp)}5`;

  const lowerBound = (value - halfNum).toFixed(dp + 1);
  const upperBound = (value + halfNum).toFixed(dp + 1);

  return { roundedValue: value, dp, degreeOfAccuracy, half, lowerBound, upperBound };
}

/** Generate a random rounded value with 1–3 decimal places. */
export function randomBoundsNumber(): { value: number; dp: number } {
  const dp = Math.floor(Math.random() * 3) + 1;
  const templates = [
    () => +(Math.random() * 20).toFixed(dp),
    () => +(Math.random() * 100).toFixed(dp),
    () => +(5 + Math.random() * 10).toFixed(dp),
    () => +(Math.random() * 50).toFixed(dp),
  ];
  const fn = templates[Math.floor(Math.random() * templates.length)];
  return { value: fn(), dp };
}
